import React from 'react';
import Section from "../Section/Section";
import IconMouse from './IconMouse';
import './ScrollArea.sass';

const ScrollArea = ({sections, isScrolling}) => {

  return (
    <div className="scrollArea">
      {
        sections && sections.map(section => {
          return (
            <Section
              slideData={section}
              index={section.id}
              key={section.id}
            />
          )
        })
      }
      <div className="scrollArea__icon">
        <IconMouse isScrolling={isScrolling}/>
      </div>
    </div>
  );

};

export default ScrollArea;
